import { ContentSkeleton } from '@/components/loading/Skeleton'
import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/state/AuthContext'
import { canAccessAdmin, canAccessPlatformAdmin } from '@/lib/adminCapabilities'
import { withoutOrganization } from '@/components/auth/isViewer'

export function AdminGuard({
  children,
  requirePlatform = false,
}: {
  children: React.ReactElement
  requirePlatform?: boolean
}) {
  const { user, organization, isAuthenticated, authReady } = useAuth()

  if (!isAuthenticated) return <Navigate to="/login" replace />
  if (!authReady) return <ContentSkeleton label="Loading admin workspace" variant="list" className="app-page max-w-7xl" />

  // A viewer, a manager of someone else's event, or an admin without an organisation has nothing to administer.
  if (withoutOrganization(organization, user)) return <Navigate to="/" replace />

  const role = user?.attributes?.role
  if (!canAccessAdmin(role)) {
    return <Navigate to="/app" replace />
  }

  if (requirePlatform && !canAccessPlatformAdmin(role)) {
    return <Navigate to="/admin" replace />
  }

  return children
}
